<template>

    <form @submit.prevent="submitForm">
        <div class="form-group">
        <input type="text" v-model="userName" name="userName" placeholder="Username">
        </div>

        <div class="form-group">
        <input type="password" v-model="password" name="password" placeholder="Password">
        </div>
        <input class="send" type="submit">
    </form>
</template>

<script>
    export default {
        name: "LoginForm",

        data: function () {
            return{
                password:"",
                userName :"",
                isLogged : false
            }

        },
        methods:{
          submitForm: function () {
              this.$emit('login',this.userName,this.password);
              
          }
        }
    }
</script>

<style scoped>
    form{
      text-align: center;
    }
input{
    padding:10px;
    border:none;
    margin:10px;
}
    .send{
        border:none;
    
        font-weight: bold;
        color:white;
        background: #9c0204;
        transition: .3s;
    }
    .send:hover{
        cursor: pointer;
        color:#9c0204;
        background: white;
    }

</style>